import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function useSearch() {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchValue = searchParams.get('search') || '';
  useEffect(() => {
    searchParams.delete('search');
    setSearchParams(searchParams);
  }, []);
  const onSearchChange = (value: string) => {
    if (value === '') {
      searchParams.delete('search');
    } else {
      searchParams.set('search', value);
    }
    setSearchParams(searchParams, { replace: true });
  };
  const clearSearch = () => {
    searchParams.delete('search');
    setSearchParams(searchParams);
  };
  return {
    searchValue,
    onSearchChange,
    clearSearch,
  };
}